module.exports = __webpack_public_path__ + "static/media/auth_figure.02ae1cd9.svg";